import { Plus } from 'lucide-react'
import { Button, InvoiceList, InvoiceForm, InvoiceFilters } from '../components'
import { useInvoices } from '../hooks/useInvoices'
import { useAuth } from '../contexts/AuthContextTest'

function Invoices() {
  const { user } = useAuth()
  
  const {
    invoices,
    isLoading,
    totalItems,
    showModal,
    editingInvoice,
    isCreating,
    isUpdating,
    searchTerm,
    setSearchTerm,
    paymentStatus,
    setPaymentStatus,
    orderStatus,
    setOrderStatus,
    handleSubmit,
    handleEdit,
    handleDelete,
    handleDownloadPDF,
    handleCloseModal,
    handleClearFilters
  } = useInvoices({}, user)

  // Check if user can create invoices
  const canCreateInvoice = user?.role?.id === 1 || user?.role?.id === 2

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-4xl font-bold text-secondary-900">Invoices</h1>
          <p className="mt-1 text-base text-secondary-600">
            Manage invoices and billing information
          </p>
        </div>
        {canCreateInvoice && (
          <Button
            onClick={() => handleEdit(null)}
            variant="primary"
            size="md"
          >
            <Plus className="h-4 w-4 mr-2" />
            Add Invoice
          </Button>
        )}
      </div>

      {/* Filters */}
      <InvoiceFilters
        searchTerm={searchTerm}
        paymentStatus={paymentStatus}
        orderStatus={orderStatus}
        onSearchChange={setSearchTerm}
        onPaymentStatusChange={setPaymentStatus}
        onOrderStatusChange={setOrderStatus}
        onClearFilters={handleClearFilters}
        totalItems={totalItems}
      />

      {/* Invoice List */}
      <InvoiceList
        invoices={invoices}
        isLoading={isLoading}
        onEdit={handleEdit}
        onDelete={handleDelete}
        onDownloadPDF={handleDownloadPDF}
      />

      {/* Invoice Form Modal */}
      <InvoiceForm
        isOpen={showModal}
        editingInvoice={editingInvoice}
        onClose={handleCloseModal}
        onSubmit={handleSubmit}
        isLoading={isCreating || isUpdating}
      />
    </div>
  )
}

export default Invoices

